module.exports = __webpack_public_path__ + "media/images/background_home_2480-800w-8cbcdb19.jpg";